import { SLOTS_APIS } from "@/api_framework/api_config";
import { IOverBookingListResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOverBookingList } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useOverBookingsListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      dispatch(
        setLoading({
          key: "isOverbookingSlotsInProgress",
          status: true,
        }),
      );
      await axios
        .get(`${SLOTS_APIS?.OVER_BOOKING_LIST?.baseURL}` ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IOverBookingListResponse>) => {
          if (res.data.status === true && res.data) {
            dispatch(
              setOverBookingList({
                data: res.data.data,
              }),
            );
            dispatch(
              setLoading({
                key: "isOverbookingSlotsInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(
              setOverBookingList({
                data: [],
              }),
            );
            dispatch(
              setLoading({
                key: "isOverbookingSlotsInProgress",
                status: false,
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            dispatch(
              setLoading({
                key: "isOverbookingSlotsInProgress",
                status: false,
              }),
            );
            toast("No records found");
          }
          if (e.status === 400) {
            dispatch(
              setLoading({
                key: "isOverbookingSlotsInProgress",
                status: false,
              }),
            );
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
